const PropTypes = require('prop-types');
const React = require('react');
const Loading = require('../shared/loading.jsx');
const PriceGuideTransaction = require('./price_guide_transaction.jsx');
const PriceGuidePaginationButton = require('./price_guide_pagination_button.jsx');

class MatchedPriceGuide extends React.Component {
  static get propTypes() {
    return {
      transactions: PropTypes.object.isRequired,
      followPagination: PropTypes.func.isRequired,
    };
  }

  renderPagination() {
    if (!(this.props.transactions.transactions && this.props.transactions.transactions.length)) {
      return false;
    }

    return (
      <nav className="table-nav pull-right">
        <PriceGuidePaginationButton
          links={this.props.transactions._links}
          link="prev"
          followPagination={(url) => this.props.followPagination(url)}
          direction="left"
        />
        <PriceGuidePaginationButton
          links={this.props.transactions._links}
          link="next"
          followPagination={(url) => this.props.followPagination(url)}
          direction="right"
        />
      </nav>
    );
  }

  renderTransactions() {
    return this.props.transactions.transactions.map((transaction, index) =>
      <PriceGuideTransaction transaction={transaction} key={index} />
    );
  }

  renderTransactionTable() {
    if (!this.props.transactions.transactions) {
      return <Loading />;
    }

    if (!this.props.transactions.transactions.length) {
      return <p>{I18n.t('js.priceGuideMatcher.noFound')}</p>;
    }

    return (
      <div className="bordered bd-rounded">
        <table className="table transactions">
          <thead className="light-bg">
            <tr>
              <th>{I18n.t('js.priceGuideMatcher.date')}</th>
              <th>{I18n.t('js.priceGuideMatcher.condition')}</th>
              <th>{I18n.t('js.priceGuideMatcher.final')}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderTransactions()}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="strong mb-half clearfix">
          {this.renderPagination()}
          <p>{I18n.t('js.priceGuideMatcher.transactionHistory')}</p>
        </div>
        {this.renderTransactionTable()}
      </div>
    );
  }
}

module.exports = MatchedPriceGuide;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/matched_price_guide.jsx